<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="numberOfPages !== 0" class="pagination-container">
    <Paginate
      v-model="queryPagination"
      :page-count="numberOfPages"
      :page-range="3"
      :margin-pages="1"
      :click-handler="changeQueryString"
      :prev-text="`<div class='icon-search-prev'/>`"
      :next-text="`<div class='icon-search-next'/>`"
      container-class="pagination-list"
      page-class="pagination-item"
    />
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'

/**
 * Display diferent icon logo depending on type
 * @example [none]
 */
export default {
  name: 'PaginationSearch',
  components: {
    Paginate,
  },
  props: {
    /**
     * Max number of items for page
     */
    itemsForPage: {
      type: Number,
    },
    /**
     * Object with search axios result
     */
    dataSearch: {
      type: Object,
    },
  },
  data() {
    return {
      currentPage: 1,
    }
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.dataSearch.count / this.itemsForPage)
    },
    queryPagination: {
      get: function () {
        if (this.$route.query && this.$route.query.page) return parseInt(this.$route.query.page)
        else return 1
      },
      set: function (val) {
        this.currentPage = val
      },
    },
  },
  methods: {
    /**
     * Update page query params with page value obtained by params
     * @public This is a public method
     * @param {Number} page Number of page
     */
    changeQueryString(page) {
      if (!this.$route.query || (this.$route.query && page !== parseInt(this.$route.query.page))) {
        /** Triggers and event to show loading
         * @event toggle-data-loading
         */
        this.$emit('toggle-data-loading')
        window.scrollTo(0, 0)
        this.$router.push({
          query: {
            ...this.$route.query,
            page: page,
          },
        })
      }
    },
  },
}
</script>

<style lang="stylus">
.pagination-container
  display: flex
  align-items: center
  margin-top: vw(50px)

  .mobile &
    margin-top: vw(25px)
    justify-content: center

.pagination-list
  display: flex
  align-items: center
  color: $grey
  font-weight: 300
  gap: vw(10px)

  > li
    width: vw(20px)
    list-style-type: none

    &:hover
      color: #000

      .icon-search-next,
      .icon-search-prev
        background-color: #000

    > a
      m-font-size(16, 26)
      display: block
      width: vw(20px)
      color: black
      text-align: center

  .active
    margin-top: -0.1em
    color: #000
    font-weight: 700

    > a
      cursor: default

  .disabled
    opacity: 0.5
    pointer-events: none

  .icon-search-next,
  .icon-search-prev
    m-icon("chevron-right", 20)
    cursor: pointer

  .icon-search-prev
    transform: rotate(180deg)
</style>
